import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { ListeChoix } from './listeChoix.model';


@Injectable()
export class ListeChoixService {

    private resourceUrl = 'api/liste-choix';

    constructor(private http: Http) { }

    create(listeChoix: ListeChoix): Observable<ListeChoix> {
        let copy: ListeChoix = Object.assign({}, listeChoix);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(listeChoix: ListeChoix): Observable<ListeChoix> {
        let copy: ListeChoix = Object.assign({}, listeChoix);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<ListeChoix> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.type) {
            params.set('type', req.type.toUpperCase());
        }
        return this.http.get(this.resourceUrl, { search: params });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    toLabelValue(listeChoix: ListeChoix[]) {
        let liste = [];
        listeChoix.forEach(choix => liste.push({label: choix.libelle, value: choix.code}));
        return liste;
    }

    toLabelValueInteger(listeChoix: ListeChoix[]) {
        let liste = [];
        listeChoix.forEach(choix => liste.push({label: choix.libelle, value: Number.parseInt(choix.code)}));
        return liste;
    }

    toLabelLabel(listeChoix: ListeChoix[]) {
        let liste = [];
        listeChoix.forEach(choix => liste.push({label: choix.libelle, value: choix.libelle}));
        return liste;
    }


    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/ListeChoix/listeChoix.service.ts